/**
 * @fileoverview gRPC-Web generated client stub for trust
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: trust/trust.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var contentstore_contentstore_pb = require('../contentstore/contentstore_pb.js')

var attachment_attachment_pb = require('../attachment/attachment_pb.js')

var chat_chat_pb = require('../chat/chat_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.trust = require('./trust_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.TrustServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.TrustServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustAccountForParentRequest,
 *   !proto.trust.GetTrustAccountResponse>}
 */
const methodDescriptor_TrustService_GetTrustAccountForParent = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustAccountForParent',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustAccountForParentRequest,
  proto.trust.GetTrustAccountResponse,
  /**
   * @param {!proto.trust.GetTrustAccountForParentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustAccountResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustAccountForParentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustAccountForParent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustAccountForParent',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustAccountForParent,
      callback);
};


/**
 * @param {!proto.trust.GetTrustAccountForParentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustAccountResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustAccountForParent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustAccountForParent',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustAccountForParent);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetAssetsResponse>}
 */
const methodDescriptor_TrustService_GetAssets = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetAssets',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetAssetsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetAssetsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetAssetsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetAssetsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getAssets =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetAssets,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetAssetsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getAssets =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetAssets);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateAssetRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateAsset = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateAsset',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateAssetRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateAssetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateAsset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAsset,
      callback);
};


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateAsset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAsset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateAssetRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_OldUpdateAsset = new grpc.web.MethodDescriptor(
  '/trust.TrustService/OldUpdateAsset',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateAssetRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateAssetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.oldUpdateAsset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/OldUpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldUpdateAsset,
      callback);
};


/**
 * @param {!proto.trust.UpdateAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.oldUpdateAsset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/OldUpdateAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldUpdateAsset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeleteAssetRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_OldDeleteAsset = new grpc.web.MethodDescriptor(
  '/trust.TrustService/OldDeleteAsset',
  grpc.web.MethodType.UNARY,
  proto.trust.DeleteAssetRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeleteAssetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeleteAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.oldDeleteAsset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/OldDeleteAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldDeleteAsset,
      callback);
};


/**
 * @param {!proto.trust.DeleteAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.oldDeleteAsset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/OldDeleteAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldDeleteAsset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeleteAssetRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteAsset = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteAsset',
  grpc.web.MethodType.UNARY,
  proto.trust.DeleteAssetRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeleteAssetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeleteAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteAsset =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteAsset,
      callback);
};


/**
 * @param {!proto.trust.DeleteAssetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteAsset =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteAsset',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteAsset);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetCompanyInfoResponse>}
 */
const methodDescriptor_TrustService_GetCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetCompanyInfo',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetCompanyInfoResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetCompanyInfoResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetCompanyInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetCompanyInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCompanyInfo,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetCompanyInfoResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddCustomFrameworkRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_AddCustomFramework = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddCustomFramework',
  grpc.web.MethodType.UNARY,
  proto.trust.AddCustomFrameworkRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.AddCustomFrameworkRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.AddCustomFrameworkRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addCustomFramework =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddCustomFramework',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddCustomFramework,
      callback);
};


/**
 * @param {!proto.trust.AddCustomFrameworkRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addCustomFramework =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddCustomFramework',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddCustomFramework);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateCustomFrameworksSelectedRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateCustomFrameworksSelected = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateCustomFrameworksSelected',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateCustomFrameworksSelectedRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateCustomFrameworksSelectedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateCustomFrameworksSelectedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateCustomFrameworksSelected =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateCustomFrameworksSelected',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCustomFrameworksSelected,
      callback);
};


/**
 * @param {!proto.trust.UpdateCustomFrameworksSelectedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateCustomFrameworksSelected =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateCustomFrameworksSelected',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCustomFrameworksSelected);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateCompanyInfoRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateCompanyInfo',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateCompanyInfoRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateCompanyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCompanyInfo,
      callback);
};


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateCompanyInfoRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_OldUpdateCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.TrustService/OldUpdateCompanyInfo',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateCompanyInfoRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateCompanyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.oldUpdateCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/OldUpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldUpdateCompanyInfo,
      callback);
};


/**
 * @param {!proto.trust.UpdateCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.oldUpdateCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/OldUpdateCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_TrustService_OldUpdateCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddDocumentRequest,
 *   !proto.trust.AddDocumentResponse>}
 */
const methodDescriptor_TrustService_AddDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.AddDocumentRequest,
  proto.trust.AddDocumentResponse,
  /**
   * @param {!proto.trust.AddDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.AddDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddDocument,
      callback);
};


/**
 * @param {!proto.trust.AddDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeleteDocumentRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.DeleteDocumentRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeleteDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteDocument,
      callback);
};


/**
 * @param {!proto.trust.DeleteDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateDocumentPrivacyRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateDocumentPrivacy = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateDocumentPrivacy',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateDocumentPrivacyRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateDocumentPrivacyRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateDocumentPrivacyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateDocumentPrivacy =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentPrivacy',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentPrivacy,
      callback);
};


/**
 * @param {!proto.trust.UpdateDocumentPrivacyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateDocumentPrivacy =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentPrivacy',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentPrivacy);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetDocumentsRequest,
 *   !proto.trust.GetDocumentsResponse>}
 */
const methodDescriptor_TrustService_GetDocuments = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetDocuments',
  grpc.web.MethodType.UNARY,
  proto.trust.GetDocumentsRequest,
  proto.trust.GetDocumentsResponse,
  /**
   * @param {!proto.trust.GetDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetDocuments',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetDocuments,
      callback);
};


/**
 * @param {!proto.trust.GetDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetDocuments',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddPlatformDocumentRequest,
 *   !proto.trust.AddPlatformDocumentResponse>}
 */
const methodDescriptor_TrustService_AddPlatformDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddPlatformDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.AddPlatformDocumentRequest,
  proto.trust.AddPlatformDocumentResponse,
  /**
   * @param {!proto.trust.AddPlatformDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddPlatformDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.AddPlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddPlatformDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddPlatformDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addPlatformDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddPlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddPlatformDocument,
      callback);
};


/**
 * @param {!proto.trust.AddPlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddPlatformDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addPlatformDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddPlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddPlatformDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeletePlatformDocumentMetadataRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeletePlatformDocumentMetadata = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeletePlatformDocumentMetadata',
  grpc.web.MethodType.UNARY,
  proto.trust.DeletePlatformDocumentMetadataRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deletePlatformDocumentMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeletePlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeletePlatformDocumentMetadata,
      callback);
};


/**
 * @param {!proto.trust.DeletePlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deletePlatformDocumentMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeletePlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeletePlatformDocumentMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.RegeneratePlatformDocumentRequest,
 *   !proto.trust.AddPlatformDocumentResponse>}
 */
const methodDescriptor_TrustService_RegeneratePlatformDocument = new grpc.web.MethodDescriptor(
  '/trust.TrustService/RegeneratePlatformDocument',
  grpc.web.MethodType.UNARY,
  proto.trust.RegeneratePlatformDocumentRequest,
  proto.trust.AddPlatformDocumentResponse,
  /**
   * @param {!proto.trust.RegeneratePlatformDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AddPlatformDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.trust.RegeneratePlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AddPlatformDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AddPlatformDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.regeneratePlatformDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/RegeneratePlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_RegeneratePlatformDocument,
      callback);
};


/**
 * @param {!proto.trust.RegeneratePlatformDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AddPlatformDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.regeneratePlatformDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/RegeneratePlatformDocument',
      request,
      metadata || {},
      methodDescriptor_TrustService_RegeneratePlatformDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.ListOriginsResponse>}
 */
const methodDescriptor_TrustService_ListOrigins = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListOrigins',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.ListOriginsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListOriginsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListOriginsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListOriginsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listOrigins =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListOrigins',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListOrigins,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListOriginsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listOrigins =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListOrigins',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListOrigins);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetPlatformDocumentMetadataRequest,
 *   !proto.trust.GetPlatformDocumentMetadataResponse>}
 */
const methodDescriptor_TrustService_GetPlatformDocumentMetadata = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetPlatformDocumentMetadata',
  grpc.web.MethodType.UNARY,
  proto.trust.GetPlatformDocumentMetadataRequest,
  proto.trust.GetPlatformDocumentMetadataResponse,
  /**
   * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetPlatformDocumentMetadataResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetPlatformDocumentMetadataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetPlatformDocumentMetadataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getPlatformDocumentMetadata =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetPlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetPlatformDocumentMetadata,
      callback);
};


/**
 * @param {!proto.trust.GetPlatformDocumentMetadataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetPlatformDocumentMetadataResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getPlatformDocumentMetadata =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetPlatformDocumentMetadata',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetPlatformDocumentMetadata);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GenerateSummaryRequest,
 *   !proto.trust.GenerateSummaryResponse>}
 */
const methodDescriptor_TrustService_GenerateSummary = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GenerateSummary',
  grpc.web.MethodType.UNARY,
  proto.trust.GenerateSummaryRequest,
  proto.trust.GenerateSummaryResponse,
  /**
   * @param {!proto.trust.GenerateSummaryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GenerateSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GenerateSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GenerateSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GenerateSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.generateSummary =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GenerateSummary',
      request,
      metadata || {},
      methodDescriptor_TrustService_GenerateSummary,
      callback);
};


/**
 * @param {!proto.trust.GenerateSummaryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GenerateSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.generateSummary =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GenerateSummary',
      request,
      metadata || {},
      methodDescriptor_TrustService_GenerateSummary);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.SummarizeRequest,
 *   !proto.trust.GenerateSummaryResponse>}
 */
const methodDescriptor_TrustService_Summarize = new grpc.web.MethodDescriptor(
  '/trust.TrustService/Summarize',
  grpc.web.MethodType.UNARY,
  proto.trust.SummarizeRequest,
  proto.trust.GenerateSummaryResponse,
  /**
   * @param {!proto.trust.SummarizeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GenerateSummaryResponse.deserializeBinary
);


/**
 * @param {!proto.trust.SummarizeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GenerateSummaryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GenerateSummaryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.summarize =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/Summarize',
      request,
      metadata || {},
      methodDescriptor_TrustService_Summarize,
      callback);
};


/**
 * @param {!proto.trust.SummarizeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GenerateSummaryResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.summarize =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/Summarize',
      request,
      metadata || {},
      methodDescriptor_TrustService_Summarize);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.ListNotificationEmailsResponse>}
 */
const methodDescriptor_TrustService_ListNotificationEmails = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListNotificationEmails',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.ListNotificationEmailsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListNotificationEmailsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListNotificationEmailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListNotificationEmailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listNotificationEmails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListNotificationEmails,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListNotificationEmailsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listNotificationEmails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListNotificationEmails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateNotificationEmailsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateNotificationEmails = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateNotificationEmails',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateNotificationEmailsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateNotificationEmailsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateNotificationEmailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateNotificationEmails =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateNotificationEmails,
      callback);
};


/**
 * @param {!proto.trust.UpdateNotificationEmailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateNotificationEmails =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateNotificationEmails',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateNotificationEmails);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetNdaTemplateBlocksResponse>}
 */
const methodDescriptor_TrustService_GetNdaTemplateBlocks = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetNdaTemplateBlocks',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetNdaTemplateBlocksResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetNdaTemplateBlocksResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetNdaTemplateBlocksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetNdaTemplateBlocksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getNdaTemplateBlocks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetNdaTemplateBlocks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetNdaTemplateBlocks,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetNdaTemplateBlocksResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getNdaTemplateBlocks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetNdaTemplateBlocks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetNdaTemplateBlocks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetCustomFrameworksResponse>}
 */
const methodDescriptor_TrustService_GetCustomFrameworks = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetCustomFrameworks',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetCustomFrameworksResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetCustomFrameworksResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetCustomFrameworksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetCustomFrameworksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getCustomFrameworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetCustomFrameworks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCustomFrameworks,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetCustomFrameworksResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getCustomFrameworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetCustomFrameworks',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCustomFrameworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.InviteUserRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_InviteUser = new grpc.web.MethodDescriptor(
  '/trust.TrustService/InviteUser',
  grpc.web.MethodType.UNARY,
  proto.trust.InviteUserRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.InviteUserRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.InviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.inviteUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/InviteUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_InviteUser,
      callback);
};


/**
 * @param {!proto.trust.InviteUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.inviteUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/InviteUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_InviteUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ListUsersRequest,
 *   !proto.trust.ListUsersResponse>}
 */
const methodDescriptor_TrustService_ListUsers = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListUsers',
  grpc.web.MethodType.UNARY,
  proto.trust.ListUsersRequest,
  proto.trust.ListUsersResponse,
  /**
   * @param {!proto.trust.ListUsersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListUsersResponse.deserializeBinary
);


/**
 * @param {!proto.trust.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListUsersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListUsersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listUsers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListUsers,
      callback);
};


/**
 * @param {!proto.trust.ListUsersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListUsersResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listUsers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListUsers',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListUsers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateUserStatusRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateUserStatus = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateUserStatus',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateUserStatusRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateUserStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateUserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateUserStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateUserStatus,
      callback);
};


/**
 * @param {!proto.trust.UpdateUserStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateUserStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateUserStatus',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateUserStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.AdminExchangeTokenResponse>}
 */
const methodDescriptor_TrustService_AdminExchangeToken = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AdminExchangeToken',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.AdminExchangeTokenResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.AdminExchangeTokenResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.AdminExchangeTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.AdminExchangeTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.adminExchangeToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AdminExchangeToken',
      request,
      metadata || {},
      methodDescriptor_TrustService_AdminExchangeToken,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.AdminExchangeTokenResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.adminExchangeToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AdminExchangeToken',
      request,
      metadata || {},
      methodDescriptor_TrustService_AdminExchangeToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.PolicyDisplayOverrideRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateTrustPortalPolicies = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTrustPortalPolicies',
  grpc.web.MethodType.UNARY,
  proto.trust.PolicyDisplayOverrideRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.PolicyDisplayOverrideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.PolicyDisplayOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTrustPortalPolicies =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalPolicies',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalPolicies,
      callback);
};


/**
 * @param {!proto.trust.PolicyDisplayOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTrustPortalPolicies =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalPolicies',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalPolicies);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ControlDisplayOverrideRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateTrustPortalControls = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTrustPortalControls',
  grpc.web.MethodType.UNARY,
  proto.trust.ControlDisplayOverrideRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.ControlDisplayOverrideRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.ControlDisplayOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTrustPortalControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalControls,
      callback);
};


/**
 * @param {!proto.trust.ControlDisplayOverrideRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTrustPortalControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.TrustPortalControlsResponse>}
 */
const methodDescriptor_TrustService_GetTrustPortalControls = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustPortalControls',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.TrustPortalControlsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalControlsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalControlsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalControlsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustPortalControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalControls,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalControlsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustPortalControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.PublishRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_Publish = new grpc.web.MethodDescriptor(
  '/trust.TrustService/Publish',
  grpc.web.MethodType.UNARY,
  proto.trust.PublishRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.PublishRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.PublishRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.publish =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/Publish',
      request,
      metadata || {},
      methodDescriptor_TrustService_Publish,
      callback);
};


/**
 * @param {!proto.trust.PublishRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.publish =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/Publish',
      request,
      metadata || {},
      methodDescriptor_TrustService_Publish);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetCategoriesOptionsRequest,
 *   !proto.trust.CategoryOptions>}
 */
const methodDescriptor_TrustService_GetCategoriesOptions = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetCategoriesOptions',
  grpc.web.MethodType.UNARY,
  proto.trust.GetCategoriesOptionsRequest,
  proto.trust.CategoryOptions,
  /**
   * @param {!proto.trust.GetCategoriesOptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.CategoryOptions.deserializeBinary
);


/**
 * @param {!proto.trust.GetCategoriesOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.CategoryOptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.CategoryOptions>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getCategoriesOptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetCategoriesOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCategoriesOptions,
      callback);
};


/**
 * @param {!proto.trust.GetCategoriesOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.CategoryOptions>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getCategoriesOptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetCategoriesOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetCategoriesOptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.CategoryUpdateRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateCategoryOptions = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateCategoryOptions',
  grpc.web.MethodType.UNARY,
  proto.trust.CategoryUpdateRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.CategoryUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.CategoryUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateCategoryOptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateCategoryOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCategoryOptions,
      callback);
};


/**
 * @param {!proto.trust.CategoryUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateCategoryOptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateCategoryOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateCategoryOptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.CategoryDeleteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteCategoryOptions = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteCategoryOptions',
  grpc.web.MethodType.UNARY,
  proto.trust.CategoryDeleteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.CategoryDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.CategoryDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteCategoryOptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteCategoryOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteCategoryOptions,
      callback);
};


/**
 * @param {!proto.trust.CategoryDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteCategoryOptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteCategoryOptions',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteCategoryOptions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateDocumentCategoryRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateDocumentCategory = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateDocumentCategory',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateDocumentCategoryRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateDocumentCategoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateDocumentCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateDocumentCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentCategory',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentCategory,
      callback);
};


/**
 * @param {!proto.trust.UpdateDocumentCategoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateDocumentCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateDocumentCategory',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateDocumentCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.TrustPortalFaqsResponse>}
 */
const methodDescriptor_TrustService_GetTrustPortalFaqs = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustPortalFaqs',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.TrustPortalFaqsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalFaqsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalFaqsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalFaqsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustPortalFaqs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalFaqs,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalFaqsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustPortalFaqs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalFaqs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.TrustPortalFaqsUpdateRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateTrustPortalFaqs = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTrustPortalFaqs',
  grpc.web.MethodType.UNARY,
  proto.trust.TrustPortalFaqsUpdateRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.TrustPortalFaqsUpdateRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.TrustPortalFaqsUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTrustPortalFaqs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalFaqs,
      callback);
};


/**
 * @param {!proto.trust.TrustPortalFaqsUpdateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTrustPortalFaqs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalFaqs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.TrustPortalFaqsDeleteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteTrustPortalFaqs = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteTrustPortalFaqs',
  grpc.web.MethodType.UNARY,
  proto.trust.TrustPortalFaqsDeleteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.TrustPortalFaqsDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.TrustPortalFaqsDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteTrustPortalFaqs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalFaqs,
      callback);
};


/**
 * @param {!proto.trust.TrustPortalFaqsDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteTrustPortalFaqs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalFaqs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.TrustPortalUpdatesResponse>}
 */
const methodDescriptor_TrustService_GetTrustPortalUpdates = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustPortalUpdates',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.TrustPortalUpdatesResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalUpdatesResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalUpdatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalUpdatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustPortalUpdates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalUpdates,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalUpdatesResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustPortalUpdates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalUpdates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.TrustPortalUpdatesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateTrustPortalUpdates = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTrustPortalUpdates',
  grpc.web.MethodType.UNARY,
  proto.trust.TrustPortalUpdatesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.TrustPortalUpdatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.TrustPortalUpdatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTrustPortalUpdates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalUpdates,
      callback);
};


/**
 * @param {!proto.trust.TrustPortalUpdatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTrustPortalUpdates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTrustPortalUpdates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.TrustPortalUpdatesDeleteRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteTrustPortalUpdates = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteTrustPortalUpdates',
  grpc.web.MethodType.UNARY,
  proto.trust.TrustPortalUpdatesDeleteRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.TrustPortalUpdatesDeleteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.TrustPortalUpdatesDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteTrustPortalUpdates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalUpdates,
      callback);
};


/**
 * @param {!proto.trust.TrustPortalUpdatesDeleteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteTrustPortalUpdates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalUpdates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.TiConfigResponse>}
 */
const methodDescriptor_TrustService_GetTiConfig = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTiConfig',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.TiConfigResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTiConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTiConfig,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TiConfigResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTiConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateTiConfigRequest,
 *   !proto.trust.TiConfigResponse>}
 */
const methodDescriptor_TrustService_UpdateTiConfig = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTiConfig',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateTiConfigRequest,
  proto.trust.TiConfigResponse,
  /**
   * @param {!proto.trust.UpdateTiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateTiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTiConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTiConfig,
      callback);
};


/**
 * @param {!proto.trust.UpdateTiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TiConfigResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTiConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateTiCreditsRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateTiCredits = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateTiCredits',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateTiCreditsRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateTiCreditsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateTiCreditsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateTiCredits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateTiCredits',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTiCredits,
      callback);
};


/**
 * @param {!proto.trust.UpdateTiCreditsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateTiCredits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateTiCredits',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateTiCredits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.ListPendingTiCreditsResponse>}
 */
const methodDescriptor_TrustService_ListPendingTiCreditsRequests = new grpc.web.MethodDescriptor(
  '/trust.TrustService/ListPendingTiCreditsRequests',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.ListPendingTiCreditsResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListPendingTiCreditsResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListPendingTiCreditsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListPendingTiCreditsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.listPendingTiCreditsRequests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/ListPendingTiCreditsRequests',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListPendingTiCreditsRequests,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListPendingTiCreditsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.listPendingTiCreditsRequests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/ListPendingTiCreditsRequests',
      request,
      metadata || {},
      methodDescriptor_TrustService_ListPendingTiCreditsRequests);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetTotalCreditsByUserResponse>}
 */
const methodDescriptor_TrustService_GetTotalCreditsByUser = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTotalCreditsByUser',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetTotalCreditsByUserResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTotalCreditsByUserResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTotalCreditsByUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTotalCreditsByUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTotalCreditsByUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTotalCreditsByUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTotalCreditsByUser,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTotalCreditsByUserResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTotalCreditsByUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTotalCreditsByUser',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTotalCreditsByUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.TrustPortalAccessGrantConfig>}
 */
const methodDescriptor_TrustService_GetAccessGrantConfig = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetAccessGrantConfig',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.TrustPortalAccessGrantConfig,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalAccessGrantConfig.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalAccessGrantConfig)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalAccessGrantConfig>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getAccessGrantConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetAccessGrantConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetAccessGrantConfig,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalAccessGrantConfig>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getAccessGrantConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetAccessGrantConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetAccessGrantConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.TrustPortalAccessGrantConfig,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_UpdateAccessGrantConfig = new grpc.web.MethodDescriptor(
  '/trust.TrustService/UpdateAccessGrantConfig',
  grpc.web.MethodType.UNARY,
  proto.trust.TrustPortalAccessGrantConfig,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.TrustPortalAccessGrantConfig} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.TrustPortalAccessGrantConfig} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.updateAccessGrantConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/UpdateAccessGrantConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAccessGrantConfig,
      callback);
};


/**
 * @param {!proto.trust.TrustPortalAccessGrantConfig} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.updateAccessGrantConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/UpdateAccessGrantConfig',
      request,
      metadata || {},
      methodDescriptor_TrustService_UpdateAccessGrantConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.AddEditTrustPortalDomainBlacklistRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_AddEditTrustPortalDomainBlacklist = new grpc.web.MethodDescriptor(
  '/trust.TrustService/AddEditTrustPortalDomainBlacklist',
  grpc.web.MethodType.UNARY,
  proto.trust.AddEditTrustPortalDomainBlacklistRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.AddEditTrustPortalDomainBlacklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.AddEditTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.addEditTrustPortalDomainBlacklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/AddEditTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddEditTrustPortalDomainBlacklist,
      callback);
};


/**
 * @param {!proto.trust.AddEditTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.addEditTrustPortalDomainBlacklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/AddEditTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_AddEditTrustPortalDomainBlacklist);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetTrustPortalDomainBlacklistResponse>}
 */
const methodDescriptor_TrustService_GetTrustPortalDomainBlacklist = new grpc.web.MethodDescriptor(
  '/trust.TrustService/GetTrustPortalDomainBlacklist',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetTrustPortalDomainBlacklistResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustPortalDomainBlacklistResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustPortalDomainBlacklistResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustPortalDomainBlacklistResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.getTrustPortalDomainBlacklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalDomainBlacklist,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustPortalDomainBlacklistResponse>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.getTrustPortalDomainBlacklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/GetTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_GetTrustPortalDomainBlacklist);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.DeleteTrustPortalDomainBlacklistRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_TrustService_DeleteTrustPortalDomainBlacklist = new grpc.web.MethodDescriptor(
  '/trust.TrustService/DeleteTrustPortalDomainBlacklist',
  grpc.web.MethodType.UNARY,
  proto.trust.DeleteTrustPortalDomainBlacklistRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.DeleteTrustPortalDomainBlacklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.DeleteTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.TrustServiceClient.prototype.deleteTrustPortalDomainBlacklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalDomainBlacklist,
      callback);
};


/**
 * @param {!proto.trust.DeleteTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.TrustServicePromiseClient.prototype.deleteTrustPortalDomainBlacklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.TrustService/DeleteTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_TrustService_DeleteTrustPortalDomainBlacklist);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.PublicTrustServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.trust.PublicTrustServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustAccountRequest,
 *   !proto.trust.GetTrustAccountResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustAccount = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustAccount',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustAccountRequest,
  proto.trust.GetTrustAccountResponse,
  /**
   * @param {!proto.trust.GetTrustAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustAccountResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustAccount',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustAccount,
      callback);
};


/**
 * @param {!proto.trust.GetTrustAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustAccountResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustAccount',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustAccount);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetCompanyInfoRequest,
 *   !proto.trust.GetCompanyInfoResponse>}
 */
const methodDescriptor_PublicTrustService_GetCompanyInfo = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetCompanyInfo',
  grpc.web.MethodType.UNARY,
  proto.trust.GetCompanyInfoRequest,
  proto.trust.GetCompanyInfoResponse,
  /**
   * @param {!proto.trust.GetCompanyInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetCompanyInfoResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetCompanyInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetCompanyInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getCompanyInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCompanyInfo,
      callback);
};


/**
 * @param {!proto.trust.GetCompanyInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetCompanyInfoResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getCompanyInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetCompanyInfo',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCompanyInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetAssetsRequest,
 *   !proto.trust.GetAssetsResponse>}
 */
const methodDescriptor_PublicTrustService_GetAssets = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetAssets',
  grpc.web.MethodType.UNARY,
  proto.trust.GetAssetsRequest,
  proto.trust.GetAssetsResponse,
  /**
   * @param {!proto.trust.GetAssetsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetAssetsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetAssetsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetAssetsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetAssetsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getAssets =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetAssets,
      callback);
};


/**
 * @param {!proto.trust.GetAssetsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetAssetsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getAssets =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetAssets',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetAssets);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorDocumentsRequest,
 *   !proto.trust.GetVisitorDocumentsResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorDocuments = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorDocuments',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorDocumentsRequest,
  proto.trust.GetVisitorDocumentsResponse,
  /**
   * @param {!proto.trust.GetVisitorDocumentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetVisitorDocumentsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetVisitorDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetVisitorDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorDocuments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorDocuments',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorDocuments,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetVisitorDocumentsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorDocuments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorDocuments',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorDocuments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustDocumentDownloadUrlRequest,
 *   !proto.contentstore.URL>}
 */
const methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustDocumentDownloadUrlRequest,
  contentstore_contentstore_pb.URL,
  /**
   * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  contentstore_contentstore_pb.URL.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contentstore.URL)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contentstore.URL>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustDocumentDownloadUrl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl,
      callback);
};


/**
 * @param {!proto.trust.GetTrustDocumentDownloadUrlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contentstore.URL>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustDocumentDownloadUrl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentDownloadUrl',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentDownloadUrl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorAccessGrantRequest,
 *   !proto.trust.GetVisitorAccessGrantResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorAccessGrant = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorAccessGrant',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorAccessGrantRequest,
  proto.trust.GetVisitorAccessGrantResponse,
  /**
   * @param {!proto.trust.GetVisitorAccessGrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetVisitorAccessGrantResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetVisitorAccessGrantResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetVisitorAccessGrantResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorAccessGrant =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorAccessGrant',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorAccessGrant,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetVisitorAccessGrantResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorAccessGrant =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorAccessGrant',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorAccessGrant);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.CreateUpdateAccessGrantRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
  grpc.web.MethodType.UNARY,
  proto.trust.CreateUpdateAccessGrantRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.CreateUpdateAccessGrantRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.CreateUpdateAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.createOrUpdateAccessGrantRequest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest,
      callback);
};


/**
 * @param {!proto.trust.CreateUpdateAccessGrantRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.createOrUpdateAccessGrantRequest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/CreateOrUpdateAccessGrantRequest',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_CreateOrUpdateAccessGrantRequest);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ExchangeTokenRequest,
 *   !proto.trust.ExchangeTokenResponse>}
 */
const methodDescriptor_PublicTrustService_ExchangeToken = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/ExchangeToken',
  grpc.web.MethodType.UNARY,
  proto.trust.ExchangeTokenRequest,
  proto.trust.ExchangeTokenResponse,
  /**
   * @param {!proto.trust.ExchangeTokenRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ExchangeTokenResponse.deserializeBinary
);


/**
 * @param {!proto.trust.ExchangeTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ExchangeTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ExchangeTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.exchangeToken =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/ExchangeToken',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ExchangeToken,
      callback);
};


/**
 * @param {!proto.trust.ExchangeTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ExchangeTokenResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.exchangeToken =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/ExchangeToken',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ExchangeToken);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustDocumentWatermarkedDataRequest,
 *   !proto.trust.GetTrustDocumentWatermarkedDataResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustDocumentWatermarkedDataRequest,
  proto.trust.GetTrustDocumentWatermarkedDataResponse,
  /**
   * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustDocumentWatermarkedDataResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustDocumentWatermarkedDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustDocumentWatermarkedDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustDocumentWatermarkedData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData,
      callback);
};


/**
 * @param {!proto.trust.GetTrustDocumentWatermarkedDataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustDocumentWatermarkedDataResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustDocumentWatermarkedData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustDocumentWatermarkedData',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustDocumentWatermarkedData);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetControlsRequests,
 *   !proto.trust.TrustPortalControlsResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustPortalControls = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustPortalControls',
  grpc.web.MethodType.UNARY,
  proto.trust.GetControlsRequests,
  proto.trust.TrustPortalControlsResponse,
  /**
   * @param {!proto.trust.GetControlsRequests} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalControlsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetControlsRequests} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalControlsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalControlsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustPortalControls =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalControls,
      callback);
};


/**
 * @param {!proto.trust.GetControlsRequests} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalControlsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustPortalControls =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalControls',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalControls);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetCustomFrameworksRequest,
 *   !proto.trust.GetCustomFrameworksResponse>}
 */
const methodDescriptor_PublicTrustService_GetCustomFrameworks = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetCustomFrameworks',
  grpc.web.MethodType.UNARY,
  proto.trust.GetCustomFrameworksRequest,
  proto.trust.GetCustomFrameworksResponse,
  /**
   * @param {!proto.trust.GetCustomFrameworksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetCustomFrameworksResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetCustomFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetCustomFrameworksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetCustomFrameworksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getCustomFrameworks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetCustomFrameworks',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCustomFrameworks,
      callback);
};


/**
 * @param {!proto.trust.GetCustomFrameworksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetCustomFrameworksResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getCustomFrameworks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetCustomFrameworks',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetCustomFrameworks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustPortalFaqsRequest,
 *   !proto.trust.TrustPortalFaqsResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustPortalFaqs = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustPortalFaqs',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustPortalFaqsRequest,
  proto.trust.TrustPortalFaqsResponse,
  /**
   * @param {!proto.trust.GetTrustPortalFaqsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalFaqsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustPortalFaqsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalFaqsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalFaqsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustPortalFaqs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalFaqs,
      callback);
};


/**
 * @param {!proto.trust.GetTrustPortalFaqsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalFaqsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustPortalFaqs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalFaqs',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalFaqs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetTrustPortalUpdatesRequest,
 *   !proto.trust.TrustPortalUpdatesResponse>}
 */
const methodDescriptor_PublicTrustService_GetTrustPortalUpdates = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetTrustPortalUpdates',
  grpc.web.MethodType.UNARY,
  proto.trust.GetTrustPortalUpdatesRequest,
  proto.trust.TrustPortalUpdatesResponse,
  /**
   * @param {!proto.trust.GetTrustPortalUpdatesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.TrustPortalUpdatesResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetTrustPortalUpdatesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.TrustPortalUpdatesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.TrustPortalUpdatesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getTrustPortalUpdates =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalUpdates,
      callback);
};


/**
 * @param {!proto.trust.GetTrustPortalUpdatesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.TrustPortalUpdatesResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getTrustPortalUpdates =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetTrustPortalUpdates',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetTrustPortalUpdates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetNdaForVisitorRequest,
 *   !proto.trust.GetNdaForVisitorResponse>}
 */
const methodDescriptor_PublicTrustService_GetNdaForVisitor = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetNdaForVisitor',
  grpc.web.MethodType.UNARY,
  proto.trust.GetNdaForVisitorRequest,
  proto.trust.GetNdaForVisitorResponse,
  /**
   * @param {!proto.trust.GetNdaForVisitorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetNdaForVisitorResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetNdaForVisitorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetNdaForVisitorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getNdaForVisitor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetNdaForVisitor,
      callback);
};


/**
 * @param {!proto.trust.GetNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetNdaForVisitorResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getNdaForVisitor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetNdaForVisitor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.SignNdaForVisitorRequest,
 *   !proto.trust.SignNdaForVisitorResponse>}
 */
const methodDescriptor_PublicTrustService_SignNdaForVisitor = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/SignNdaForVisitor',
  grpc.web.MethodType.UNARY,
  proto.trust.SignNdaForVisitorRequest,
  proto.trust.SignNdaForVisitorResponse,
  /**
   * @param {!proto.trust.SignNdaForVisitorRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.SignNdaForVisitorResponse.deserializeBinary
);


/**
 * @param {!proto.trust.SignNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.SignNdaForVisitorResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.SignNdaForVisitorResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.signNdaForVisitor =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/SignNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SignNdaForVisitor,
      callback);
};


/**
 * @param {!proto.trust.SignNdaForVisitorRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.SignNdaForVisitorResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.signNdaForVisitor =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/SignNdaForVisitor',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SignNdaForVisitor);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.RecordTrustPortalVisitorActionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PublicTrustService_RecordTrustPortalVisitorAction = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/RecordTrustPortalVisitorAction',
  grpc.web.MethodType.UNARY,
  proto.trust.RecordTrustPortalVisitorActionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.RecordTrustPortalVisitorActionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.RecordTrustPortalVisitorActionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.recordTrustPortalVisitorAction =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/RecordTrustPortalVisitorAction',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_RecordTrustPortalVisitorAction,
      callback);
};


/**
 * @param {!proto.trust.RecordTrustPortalVisitorActionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.recordTrustPortalVisitorAction =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/RecordTrustPortalVisitorAction',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_RecordTrustPortalVisitorAction);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorTiConfigRequest,
 *   !proto.trust.GetVisitorTiConfigResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorTiConfig = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorTiConfig',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorTiConfigRequest,
  proto.trust.GetVisitorTiConfigResponse,
  /**
   * @param {!proto.trust.GetVisitorTiConfigRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetVisitorTiConfigResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorTiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetVisitorTiConfigResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetVisitorTiConfigResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorTiConfig =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorTiConfig',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorTiConfig,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorTiConfigRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetVisitorTiConfigResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorTiConfig =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorTiConfig',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorTiConfig);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.trust.GetChatResponse>}
 */
const methodDescriptor_PublicTrustService_GetChat = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetChat',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.trust.GetChatResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetChatResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetChatResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetChatResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetChat',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetChat,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetChatResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetChat',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetChat);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.SendChatMessageRequest,
 *   !proto.trust.SendChatMessageResponse>}
 */
const methodDescriptor_PublicTrustService_SendChatMessage = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/SendChatMessage',
  grpc.web.MethodType.UNARY,
  proto.trust.SendChatMessageRequest,
  proto.trust.SendChatMessageResponse,
  /**
   * @param {!proto.trust.SendChatMessageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.SendChatMessageResponse.deserializeBinary
);


/**
 * @param {!proto.trust.SendChatMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.SendChatMessageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.SendChatMessageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.sendChatMessage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/SendChatMessage',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SendChatMessage,
      callback);
};


/**
 * @param {!proto.trust.SendChatMessageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.SendChatMessageResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.sendChatMessage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/SendChatMessage',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_SendChatMessage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PublicTrustService_RequestTiCredits = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/RequestTiCredits',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.requestTiCredits =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/RequestTiCredits',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_RequestTiCredits,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.requestTiCredits =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/RequestTiCredits',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_RequestTiCredits);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.GetVisitorTrustPortalDomainBlacklistRequest,
 *   !proto.trust.GetTrustPortalDomainBlacklistResponse>}
 */
const methodDescriptor_PublicTrustService_GetVisitorTrustPortalDomainBlacklist = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/GetVisitorTrustPortalDomainBlacklist',
  grpc.web.MethodType.UNARY,
  proto.trust.GetVisitorTrustPortalDomainBlacklistRequest,
  proto.trust.GetTrustPortalDomainBlacklistResponse,
  /**
   * @param {!proto.trust.GetVisitorTrustPortalDomainBlacklistRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.GetTrustPortalDomainBlacklistResponse.deserializeBinary
);


/**
 * @param {!proto.trust.GetVisitorTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.GetTrustPortalDomainBlacklistResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.GetTrustPortalDomainBlacklistResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.getVisitorTrustPortalDomainBlacklist =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorTrustPortalDomainBlacklist,
      callback);
};


/**
 * @param {!proto.trust.GetVisitorTrustPortalDomainBlacklistRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.GetTrustPortalDomainBlacklistResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.getVisitorTrustPortalDomainBlacklist =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/GetVisitorTrustPortalDomainBlacklist',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_GetVisitorTrustPortalDomainBlacklist);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.UpdateVisitorSubscriptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_PublicTrustService_UpdateVisitorSubscription = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/UpdateVisitorSubscription',
  grpc.web.MethodType.UNARY,
  proto.trust.UpdateVisitorSubscriptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.trust.UpdateVisitorSubscriptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.trust.UpdateVisitorSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.updateVisitorSubscription =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/UpdateVisitorSubscription',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_UpdateVisitorSubscription,
      callback);
};


/**
 * @param {!proto.trust.UpdateVisitorSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.updateVisitorSubscription =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/UpdateVisitorSubscription',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_UpdateVisitorSubscription);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.trust.ListVisitorNotificationSubscriptionsRequest,
 *   !proto.trust.ListVisitorNotificationSubscriptionsResponse>}
 */
const methodDescriptor_PublicTrustService_ListVisitorNotificationSubscriptions = new grpc.web.MethodDescriptor(
  '/trust.PublicTrustService/ListVisitorNotificationSubscriptions',
  grpc.web.MethodType.UNARY,
  proto.trust.ListVisitorNotificationSubscriptionsRequest,
  proto.trust.ListVisitorNotificationSubscriptionsResponse,
  /**
   * @param {!proto.trust.ListVisitorNotificationSubscriptionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.trust.ListVisitorNotificationSubscriptionsResponse.deserializeBinary
);


/**
 * @param {!proto.trust.ListVisitorNotificationSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.trust.ListVisitorNotificationSubscriptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.trust.ListVisitorNotificationSubscriptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.trust.PublicTrustServiceClient.prototype.listVisitorNotificationSubscriptions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/trust.PublicTrustService/ListVisitorNotificationSubscriptions',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ListVisitorNotificationSubscriptions,
      callback);
};


/**
 * @param {!proto.trust.ListVisitorNotificationSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.trust.ListVisitorNotificationSubscriptionsResponse>}
 *     Promise that resolves to the response
 */
proto.trust.PublicTrustServicePromiseClient.prototype.listVisitorNotificationSubscriptions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/trust.PublicTrustService/ListVisitorNotificationSubscriptions',
      request,
      metadata || {},
      methodDescriptor_PublicTrustService_ListVisitorNotificationSubscriptions);
};


module.exports = proto.trust;

